<template>
  <component
    :is="getComponentType(field.viewType)"
    :id="field.name"
    :value="value"
    :label="field.label"
    :items="items"
    :type="field.type === 'Float' ? 'number' : 'text'"
    :readonly="field.readonly"
    :required="field.required"
    :disabled="field.disabled"
    :placeholder="field.placeholder"
    :style="computedStyle"
    :class="classes"
    :item-text="field.itemText"
    :item-value="field.itemValue"
    :rules="computedRules"
    :clearable="clearable || field.clearable"
    :suffix="field.suffix"
    @input="updateValue"
    @change="(value) => updateValue(value, 'change')"
    @contextmenu="handleContextMenu"
  />
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: null
    },
    field: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    classes: {
      type: String,
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedRules () {
      const requiredRule = value => !!value || 'Ce champ est obligatoire';

      return this.field.mandatory ? [requiredRule, ...this.rules] : this.rules;
    },
    isPicker () {
      return this.field.viewType === 'Picker';
    },
    computedStyle () {
      const styles = { ...this.field.style };

      if (this.isPicker) {
        styles.userSelect = 'none';
        styles.WebkitUserSelect = 'none';
      }

      return styles;
    }
  },
  methods: {
    getComponentType (viewType) {
      const componentTypes = {
        Text: 'v-text-field',
        Number: 'v-text-field',
        Textarea: 'v-textarea',
        Select: 'v-select',
        'Date Picker': 'v-date-picker',
        Picker: 'v-autocomplete',
        Switch: 'v-switch'
      };

      return viewType in componentTypes ? componentTypes[viewType] : 'v-text-field';
    },
    updateValue (value, event) {
      if (event === 'change' && this.$props.field.viewType !== 'Switch') return;
      let val = value;
      if (this.$props.field.viewType === 'Number') val = !Number.isNaN(parseInt(val)) ? Number(val) : 0;

      this.$emit('input', val, this.$props.field.name);
    },
    handleContextMenu (e) {
      if (this.isPicker) {
        e.preventDefault();
      }
    }
  }
};
</script>
